import {
  autoUpdate,
  computePosition,
  flip,
  offset,
  shift,
} from "@floating-ui/dom";

import {
  PREVIEW_FLOATING_OFFSET_PX,
  PREVIEW_FLOATING_VIEWPORT_PADDING_PX,
} from "../defaults";

export interface PositionedPopover {
  update(): Promise<void>;
  destroy(): void;
}

export function createPositionedPopover(
  referenceElement: HTMLElement,
  floatingElement: HTMLElement,
): PositionedPopover {
  const update = async (): Promise<void> => {
    const { x, y, strategy } = await computePosition(
      referenceElement,
      floatingElement,
      {
        placement: "top",
        strategy: "fixed",
        middleware: [
          offset(PREVIEW_FLOATING_OFFSET_PX),
          flip({ padding: PREVIEW_FLOATING_VIEWPORT_PADDING_PX }),
          shift({ padding: PREVIEW_FLOATING_VIEWPORT_PADDING_PX }),
        ],
      },
    );

    Object.assign(floatingElement.style, {
      left: `${x}px`,
      top: `${y}px`,
      position: strategy,
    });
  };

  const cleanup = autoUpdate(referenceElement, floatingElement, update);

  void update();

  return {
    update,
    destroy() {
      cleanup();
    },
  };
}
